module.exports = __webpack_public_path__ + "static/img/elegantManners3.38a49682.png";